module.exports = __webpack_public_path__ + "static/media/ClientCredentialsGrant.685f8c94.png";